import React, {Component} from 'react';
import {Field} from 'redux-form';
import * as Form from './formFieldHelpers';
import * as Buttons from '../ui/buttons';
import * as Network from '../../../../../../helpers/networkHelpers';

export default class SummaryForm extends Component {
    componentDidMount() {
        this.handleInitialise();
    }

    handleInitialise = () => {
        const {initialize, body} = this.props;
        const initialValues = {
            "type": body ? "UPDATE" : "CREATE",
            // "networkId": network_id,
            "summary": body,
        };
        initialize(initialValues);
    };

    render() {
        const {buttonHandlers, body} = this.props, numberButtons = body && 3;
            // networkTitle = Network.setNetworkTitle( network_id );
        return (
            <form className="form-standard-profile">
                <div>
                    <p className="p-tag">Your summary should make a big impact in a short amount of time, so we recommend sticking to
                        around
                        200 words.</p>
                    <div>
                        <Field
                            name="summary"
                            // placeholder={`Write your profile summary for ${ networkTitle }.`}
                            component={ Form.quill }
                        />
                    </div>
                    <Buttons.HOCFormButtons
                        numberButtons={ numberButtons }
                        { ... buttonHandlers }
                        { ...this.props }
                        useNetworkIdInsteadOfSummaryIdForDelete />
                </div>
            </form>
        )
    }
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/forms/SummaryForm.js